import type { HistoryFilters } from "@hooks/view/useHistoryPageFiltersCache";

/** The filters the Updated by picker sets. */
export type ActorFilters = Pick<
    HistoryFilters,
    "actorIds" | "actorType" | "sourceTypes" | "sourcePredicates" | "series"
>;

/** No Updated by picks. */
export const CLEARED_ACTOR_FILTERS: ActorFilters = {
    actorIds: undefined,
    actorType: undefined,
    sourceTypes: undefined,
    sourcePredicates: undefined,
    series: undefined,
};

/** No All activity object or field picks. */
export const CLEARED_OBJECT_FIELD_FILTERS = {
    activityValues: undefined,
    activityFilters: undefined,
    resourceTypes: undefined,
    fields: undefined,
} satisfies Partial<HistoryFilters>;
